import CommonNaviIconMenu from '../../common/component/NaviIconMenu'

class NaviIconMenu extends CommonNaviIconMenu {
  constructor (props) {
    super(props)
    this.naviIconSetting = [
      {
        title: 'マイページ',
        url: '/admin/',
        iconClass: 'icon-home icon-large'
      },
      {
        title: '日常業務',
        url: '/admin/routine_task_home',
        iconClass: 'icon-table icon-large'
      },
      {
        title: 'システム設定',
        url: '/admin/system_setting_home',
        iconClass: 'icon-cog icon-large'
      },
      {
        title: '個人設定',
        url: '/admin/personal_setting_home',
        iconClass: 'icon-user icon-large'
      },
      {
        title: 'アンケート',
        url: '/admin/survey_setting_home',
        iconClass: 'icon-file icon-large'
      }
    ]
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/admin/components/NaviIconMenu.js